import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Quote } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EasyTradingMatrix, UnderlyingSegment } from '../entities/easy-trading-matrix.entity';
import { UnderlyingResponse } from '../entities/underlying.entity';

@Injectable({ providedIn: 'root' })
export class TradingToolsInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #api = `${environment.apihost}/api/easytrading`;

  public loadUnderlyings(segment: UnderlyingSegment): Observable<UnderlyingResponse> {
    return this.#http.get<UnderlyingResponse>(`${this.#api}/leaderboard/${segment}`);
  }

  public getEasyTradingMatrix(isin: string): Observable<EasyTradingMatrix> {
    return this.#http.get<EasyTradingMatrix>(`${this.#api}/instrument/${isin}`);
  }

  public getUnderlyingQuotes(isins: string[]): Observable<Record<string, Quote>> {
    return this.#http.get<Record<string, Quote>>(`${environment.apihost}/api/quote/prev?isins=${isins}`);
  }
}
